import { Box, Typography, Grid } from "@mui/material";
import { PropertyRecord } from "../../types";

const PropertyEntityHeader = ({ property }: { property: PropertyRecord }) => {
  if (!property) return null;

  return (
    <Box sx={{ p: 1, bgcolor: "#f5f5f5", borderRadius: 1 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 0.5 }}>
        Blacklist Details
      </Typography>

      <Grid container spacing={0.25}>
        <Grid item xs={12}>
          <Typography variant="body2">
            <strong>Blacklist Type:</strong> Property
          </Typography>
        </Grid>

        {property.address && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Address:</strong> {property.address}
            </Typography>
          </Grid>
        )}

        {property.unit && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Unit:</strong> {property.unit}
            </Typography>
          </Grid>
        )}

        {property.city && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>City:</strong> {property.city}
            </Typography>
          </Grid>
        )}

        {property.zip && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Zip:</strong> {property.zip}
            </Typography>
          </Grid>
        )}

        {property.county && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>County:</strong> {property.county.name}
            </Typography>
          </Grid>
        )}

        {property.section && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Section:</strong> {property.section}
            </Typography>
          </Grid>
        )}

        {property.block && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Block:</strong> {property.block}
            </Typography>
          </Grid>
        )}

        {property.subdivision && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Subdivision:</strong> {property.subdivision}
            </Typography>
          </Grid>
        )}

        {property.lots && property.lots.length > 0 && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Lots:</strong> {property.lots.map((l) => l.lotNumber).join(", ")}
            </Typography>
          </Grid>
        )}

        {property.parcels && property.parcels.length > 0 && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Parcels:</strong> {property.parcels.map((p) => p.parcelId).join(", ")}
            </Typography>
          </Grid>
        )}

        {property.createdDate && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Created:</strong> {new Date(property.createdDate).toLocaleDateString()}
            </Typography>
          </Grid>
        )}

        {property.createdByUser && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Created By:</strong> {property.createdByUser.fullName}
            </Typography>
          </Grid>
        )}
      </Grid>

      {property.notes && (
        <Box sx={{ mt: 0.25 }}>
          <Typography variant="body2">
            <strong>Notes:</strong> {property.notes}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PropertyEntityHeader;
